import { Component, Input, OnInit } from '@angular/core';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonServices } from '../../../domain/service/commonService';

@Component({
  selector: 'app-property-info-step',
  templateUrl: './property-info-step.component.html',
  styleUrl: './property-info-step.component.css'
})
export class PropertyInfoStepComponent  implements OnInit{
  states: DropDownModel[] = [];
  propertyBasicInfo =  new FormGroup({
    propertyStreetAddress:new FormControl('',[Validators.required]),
    aptUnitSuite:new FormControl('',[Validators.required]),
    city:new FormControl('',[Validators.required]),
    state:new FormControl('',[Validators.required]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    startedRenting:new FormControl(new Date().toISOString().slice(0, -1),[Validators.required]),
    filingFrequency:new FormControl('',[Validators.required]),
    usePlatformToRent :new FormControl(null,[Validators.required]),
    platFormLink:new FormControl('',[Validators.required]),
  });
  constructor(private commonServices: CommonServices) { }
  ngOnInit(): void {
    this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a,b) => a.name.localeCompare(b.name));;
    });
    
  }
}
